import EllipsisIcon from '@clearkit/icons/glyphs/Ellipsis';
import DeleteIcon from '@clearkit/icons/glyphs/Trash';
import { CKActionMenu, CKButton, CKPopover } from '@clearkit/react';

import styles from './styles';

function AllowedSiteMenu({ classes, className, onDelete }) {
  return (
    <CKPopover
      baseId="allowed-site-popover"
      popover={
        // THIS IS A TEMPORARY SOLUTION
        // WE NEED TO FIGURE OUT HOW 'position: fixed;' is being added
        // FROM REAKIT
        // https://github.com/clearbit/clearbit-x/pull/6133
        <CKActionMenu className={classes.actionMenu}>
          <CKActionMenu.Item
            icon={<DeleteIcon />}
            onClick={onDelete}
            isDestructive>
            Remove domain
          </CKActionMenu.Item>
        </CKActionMenu>
      }
      options={{ placement: 'bottom-end' }}
      className="z-10"
      aria-label="Popover">
      <CKButton isSmall className={className}>
        <EllipsisIcon />
      </CKButton>
    </CKPopover>
  );
}

export default withStyles(styles)(AllowedSiteMenu);
